import React from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Button from "@material-ui/core/Button";
import SettingsIcon from "@material-ui/icons/Settings";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import Tooltip from "@material-ui/core/Tooltip";
import { green } from "@material-ui/core/colors";
import PropTypes from "prop-types";
import {
    formatMoney,
    formatDate,
    formatGuestName,
    formatStatus,
    renderSortArrow,
} from "../../lib/helperFuncs.jsx";
import {
    UNAVAILABILITY_MESSAGE,
    FIRST_PAGE,
    PREV_PAGE,
    NEXT_PAGE,
    LAST_PAGE,
    ASC,
    DESC,
    sortableFields,
    MATERIAL_UI_PROPS,
} from "../../lib/data";
import css from "../../../../sass/reservations_grid.module.scss";

import reservationsData from "../../datasource/schema/reservations.json";

const useStyles = makeStyles({
    root: {
        width: "100%",
    },
});

const ReservationsGrid = (props) => {
    const classes = useStyles();
    const rows = props.resData.AllItems.map((res) =>
        createData(res, undefined, props.fields),
    );

    const sortReservations = (params) => {
        const sortParams = { ...params };
        const { sortField } = { ...sortParams };
        if (!sortableFields.includes(sortField)) return undefined;

        switch (sortParams.sortOrder) {
            case ASC:
                sortParams.sortOrder = DESC;
                break;
            case DESC:
                sortParams.sortOrder = ASC;
                break;
        }

        props.updateGlobalSearch(
            {
                ...props.globalSearch.search[props.versionFilter],
                sortOrder: sortParams.sortOrder,
            },
            props.versionFilter,
        );

        return props.paramsChangeHandler({
            ...props.getParams,
            sortField: sortField,
            sortOrder: sortParams.sortOrder,
        });
    };

    const updatingEnvironment = (page) => {
        props.paramsChangeHandler({
            ...props.getParams,
            page,
        });
        props.updateGlobalSearch(
            {
                ...props.globalSearch.search[props.versionFilter],
                page,
            },
            props.versionFilter,
        );
    };

    const changePage = (page) => {
        const params = {
            sortOrder: props.sortOrder,
            sortField: props.sortField,
        };

        switch (page) {
            case FIRST_PAGE:
                if (props.resData.currentPage !== 1) {
                    updatingEnvironment(1);
                }
                break;
            case PREV_PAGE:
                if (
                    props.resData.prevPageUrl &&
                    1 !== props.resData.currentPage
                ) {
                    const prevPageUrlArr = props.resData.prevPageUrl.split("=");
                    const prevPageNum =
                        prevPageUrlArr[prevPageUrlArr.length - 1];

                    updatingEnvironment(prevPageNum);
                }
                break;
            case NEXT_PAGE:
                if (
                    props.resData.nextPageUrl &&
                    props.resData.lastPage !== props.resData.currentPage
                ) {
                    const nextPageUrlArr = props.resData.nextPageUrl.split("=");
                    const nextPageNum =
                        nextPageUrlArr[nextPageUrlArr.length - 1];

                    updatingEnvironment(nextPageNum);
                }
                break;
            case LAST_PAGE:
                if (props.resData.lastPage !== props.resData.currentPage) {
                    updatingEnvironment(props.resData.lastPage);
                }
        }
    };

    return (
        <Paper className={classes.root}>
            <Table aria-label="custom pagination table">
                <TableHead>
                    <TableRow key="header">
                        {props.columns.map((column) => (
                            <TableCell
                                key={column.id}
                                align={column.align}
                                style={{
                                    minWidth: column.minWidth,
                                    fontWeight: 400,
                                }}
                                onClick={() => {
                                    sortReservations({
                                        sortField: column.id,
                                        sortOrder: props.getParams.sortOrder,
                                        page: props.resData.currentPage,
                                    });
                                }}
                            >
                                {column.label}
                                {renderSortArrow(
                                    props.getParams.sortField,
                                    props.getParams.sortOrder,
                                    column.id,
                                )}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row) => {
                        const isCanceled =
                            row.status === "Отменено" ||
                            row.status === "Возврат";

                        return (
                            <TableRow
                                hover
                                tabIndex={-1}
                                key={`${row.id}/${row.created_at}`}
                            >
                                {props.columns.map((column) => {
                                    let value = row[column.id];
                                    if (!value && column.id == "order_number")
                                        value = "Номер не задан";
                                    if (!value && column.id == "promo_code")
                                        value = "---";
                                    if (!value && column.id != "status_pms") {
                                        return (
                                            <TableCell
                                                key={`${row.id}/control-btn`}
                                                style={{
                                                    backgroundColor: isCanceled
                                                        ? "pink"
                                                        : "",
                                                }}
                                            >
                                                <Button
                                                    startIcon={<SettingsIcon />}
                                                    variant={
                                                        MATERIAL_UI_PROPS
                                                            .varinats.contained
                                                    }
                                                    color={
                                                        MATERIAL_UI_PROPS.colors
                                                            .default
                                                    }
                                                    size={
                                                        MATERIAL_UI_PROPS.sizes
                                                            .small
                                                    }
                                                    component={Link}
                                                    style={{
                                                        color: "white",
                                                        backgroundColor:
                                                            green[500],
                                                    }}
                                                    to={props.editAction(
                                                        row.id,
                                                    )}
                                                >
                                                    Управление
                                                </Button>
                                            </TableCell>
                                        );
                                    }
                                    return (
                                        <TableCell
                                            key={`${value}/${column.id}`}
                                            align={column.align}
                                            style={{
                                                backgroundColor: isCanceled
                                                    ? "pink"
                                                    : "",
                                            }}
                                        >
                                            {value}
                                        </TableCell>
                                    );
                                })}
                            </TableRow>
                        );
                    })}
                    <TableRow>
                        <TableCell colSpan={10} align={"right"}>
                            <span
                                style={{
                                    verticalAlign: "middle",
                                    margin: "1rem",
                                }}
                            >
                                На странице:{" "}
                                {`${props.resData.AllItems.length}/${props.resData.perPage}`}
                            </span>
                            <span style={{ verticalAlign: "middle" }}>
                                <Tooltip title={"Первая страница"}>
                                    <span
                                        onClick={() => changePage(FIRST_PAGE)}
                                        style={{ margin: "1rem" }}
                                        className={
                                            1 !== props.resData.currentPage
                                                ? css["pagination-arrows"]
                                                : css[
                                                      "pagination-arrows__inactive"
                                                  ]
                                        }
                                    >
                                        <ArrowBackIosIcon
                                            fontSize={
                                                MATERIAL_UI_PROPS.sizes.small
                                            }
                                        />
                                        <ArrowBackIosIcon
                                            fontSize={
                                                MATERIAL_UI_PROPS.sizes.small
                                            }
                                        />
                                    </span>
                                </Tooltip>
                                <Tooltip title={"Предыдущая страница"}>
                                    <span
                                        style={{ margin: "0.5rem" }}
                                        onClick={() => changePage(PREV_PAGE)}
                                        className={
                                            1 !== props.resData.currentPage
                                                ? css["pagination-arrows"]
                                                : css[
                                                      "pagination-arrows__inactive"
                                                  ]
                                        }
                                    >
                                        <ArrowBackIosIcon
                                            fontSize={
                                                MATERIAL_UI_PROPS.sizes.small
                                            }
                                        />
                                    </span>
                                </Tooltip>
                                <div style={{ display: "inline-block" }}>
                                    <span
                                        style={{
                                            fontWeight: "900",
                                            fontSize: "21px",
                                            position: "relative",
                                            top: "-2px",
                                        }}
                                    >
                                        {props.globalSearch.search[
                                            props.versionFilter
                                        ].page ?? 1}
                                    </span>
                                </div>
                                <Tooltip title={"Следующая страница"}>
                                    <span
                                        style={{ margin: "0.5rem" }}
                                        onClick={() => changePage(NEXT_PAGE)}
                                        className={
                                            props.resData.lastPage !==
                                            props.resData.currentPage
                                                ? css["pagination-arrows"]
                                                : css[
                                                      "pagination-arrows__inactive"
                                                  ]
                                        }
                                    >
                                        <ArrowForwardIosIcon
                                            fontSize={
                                                MATERIAL_UI_PROPS.sizes.small
                                            }
                                        />
                                    </span>
                                </Tooltip>
                                <Tooltip title={"Последняя страница"}>
                                    <span
                                        onClick={() => changePage(LAST_PAGE)}
                                        style={{ margin: "1rem" }}
                                        className={
                                            props.resData.lastPage !==
                                            props.resData.currentPage
                                                ? css["pagination-arrows"]
                                                : css[
                                                      "pagination-arrows__inactive"
                                                  ]
                                        }
                                    >
                                        <ArrowForwardIosIcon
                                            fontSize={
                                                MATERIAL_UI_PROPS.sizes.small
                                            }
                                        />
                                        <ArrowForwardIosIcon
                                            fontSize={
                                                MATERIAL_UI_PROPS.sizes.small
                                            }
                                        />
                                    </span>
                                </Tooltip>
                            </span>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </Paper>
    );
};

// Helper functions

/**
 * Creates reservation row
 *
 * @param {Object} reservation
 * @param {undefined} control
 * @param {Array} roomTypes
 * @param {Array} fields
 * @param {Array} guests
 */

const createData = (reservation, control, fields) => {
    const { id, number, guest } = { ...reservation };
    const created_at = formatDate(reservation.created_at);
    const roomName = reservation.data?.denormalized?.room_type?.name
        ? reservation.data?.denormalized?.room_type?.name
        : reservation.room_type?.name
          ? reservation.room_type?.name
          : UNAVAILABILITY_MESSAGE;
    const rateName = reservation.data?.denormalized?.rate?.name
        ? reservation.data?.denormalized?.rate?.name
        : reservation.rate?.name
          ? reservation.rate?.name
          : UNAVAILABILITY_MESSAGE;
    const total = formatMoney(reservation.total);
    const date_in = formatDate(reservation.date_in);
    const date_out = formatDate(reservation.date_out);
    const status = formatStatus(reservation.status, fields);
    const guestName = formatGuestName(guest, reservation?.data?.denormalized?.guest);
    const order_number = reservation.order_number;
    const order_source =
        fields?.order_source?.values?.[reservation.order_source];
    const promo_code = reservation?.promo?.name;
    const status_pms =
        reservationsData.status_pms.values[
            reservation?.message_logs?.[reservation.message_logs.length - 1]
                ?.status
        ];
    if (Object.prototype.hasOwnProperty.call(reservation, "paid_amount")) {
        const paid_amount = formatMoney(reservation.paid_amount);
        return {
            id,
            created_at,
            number,
            guestName,
            promo_code,
            date_in,
            date_out,
            roomName,
            rateName,
            order_number,
            total,
            paid_amount,
            status,
            order_source,
            status_pms,
        };
    }

    return {
        id,
        created_at,
        number,
        guestName,
        promo_code,
        date_in,
        date_out,
        roomName,
        rateName,
        order_number,
        total,
        status,
        control,
        order_source,
        status_pms,
    };
};

ReservationsGrid.propTypes = {
    setSortOrder: PropTypes.func,
    setCurrentPage: PropTypes.func,
    sortField: PropTypes.string,
    sortOrder: PropTypes.string,
    setSortField: PropTypes.func,
    getReservations: PropTypes.func.isRequired,
    resData: PropTypes.object.isRequired,
    columns: PropTypes.array.isRequired,
    fields: PropTypes.object.isRequired,
    editAction: PropTypes.func.isRequired,
    paramsChangeHandler: PropTypes.func,
    getParams: PropTypes.object,
};

export default ReservationsGrid;
